import { createApi } from '@reduxjs/toolkit/query/react';
import { publicBaseQuery } from '@core/api';

export const brandingApi = createApi({
  reducerPath: 'brandingApi',
  baseQuery: publicBaseQuery,
  endpoints: (builder) => ({
    getAccountBranding: builder.query({
      query: (slug) => `/api/v1/public/branding/${slug}/`,
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetAccountBrandingQuery } = brandingApi;
